import CommentForm from "@/components/SocialNetworks/Comment/CommentForm";
import {useState} from "react";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import CommentItem from "@/components/SocialNetworks/Comment/CommentItem";

export default function CommentSection({postId,comments,userId,actualUserId}){

    return(
        <div>
            <CommentForm postId={postId}/>
            {comments &&(
                <div className={"grid gap-2 pt-2"}>
                    {comments.map(function(comment){
                        return(
                            <CommentItem
                                key={comment.id}
                                id={comment.id}
                                comment={comment.comment}
                                childs={comment.childs}
                                user={comment.user}
                                likes={comment.likes}
                                userId={userId}
                                createdAt={comment.created_at}
                                postId={postId}
                                parentId={comment.id}
                                actualUserId={actualUserId}
                            />
                        )
                    })}
                </div>
            )}
        </div>
    )
}